// TODO: após clonar o skeleton, ajustar os links de ambientes

// Em dev, derivar o host de onde o front foi servido (window.location.hostname)
// em vez de "localhost" fixo. Assim funciona tanto no navegador do Mac quanto
// dentro da WebView do app mobile: no emulador Android o front é servido por
// 10.0.2.2 (→ API em 10.0.2.2:8080), num device físico pelo IP da LAN, etc.
// Com "localhost" fixo, o mobile resolvia para o próprio aparelho e todas as
// requests do front falhavam.
const devHost =
	typeof window !== "undefined" && window.location && window.location.hostname
		? window.location.hostname
		: "localhost";

const dev = {
	API_ENDPOINT_URL: `http://${devHost}:8080/treino/api`,
	PUBLIC_PREFIX_PATH: "",
	MEDIA_PROCESSOR_URL: `http://${devHost}:8080/treino`,
};

const test = {
	API_ENDPOINT_URL:
		"https://seashell-app-vdcz2.ondigitalocean.app/treino-io-back2/treino/api",
	PUBLIC_PREFIX_PATH: "",
	MEDIA_PROCESSOR_URL: "http://162.243.160.217:8080/treino",
};

const prod = {
	API_ENDPOINT_URL:
		"https://treino-io-back-pdafs.ondigitalocean.app/treino-io-back2/treino/api",
	PUBLIC_PREFIX_PATH: "",
	MEDIA_PROCESSOR_URL: "https://midia.treino.io/treino",
};

const getEnv = () => {
	switch (process.env.REACT_APP_ENV) {
		case "development":
			return dev;
		case "production":
			return prod;
		case "test":
			return test;
		default:
			return dev;
	}
};

export const env = getEnv();
